var _rect, _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkthroughMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.55933,
    y: 1.91309,
    width: 32,
    height: 32,
    stroke: "#151515",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5596 26.3432C17.5596 26.3432 23.5096 19.1036 23.5096 15.9579C23.5096 12.8121 20.8461 10.2627 17.5596 10.2627C14.2731 10.2627 11.6096 12.8121 11.6096 15.9579C11.6096 19.1036 17.5596 26.3432 17.5596 26.3432Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5594 26.3442C17.5594 26.3442 23.5094 19.1046 23.5094 15.9589C23.5094 12.8131 20.8459 10.2637 17.5594 10.2637C14.2729 10.2637 11.6094 12.8131 11.6094 15.9589C11.6094 19.1046 17.5594 26.3442 17.5594 26.3442Z",
    fill: "#151515",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3836,
    cy: 15.4627,
    rx: 2.275,
    ry: 2.17757,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkthroughMap);
export default __webpack_public_path__ + "static/media/walkthrough-map.bc86e496edfff5ee7eb4ac0f7309abb9.svg";
export { ForwardRef as ReactComponent };